import { FC, useEffect, useState } from "react";
import { ArrowConfig } from "common";
import { useArrows, useNav } from "hooks";
import { Arrow } from "./arrow";

export const RenderArrows: FC<any> = ({ arrowConfig, routeDefinitions }) => {
  const { arrows, nextPage } = useNav({ arrowConfig, routeDefinitions });

  return arrows.map((arrow: ArrowConfig, index: number) =>
    arrow.a === "" ? (
      <span key={index}></span>
    ) : (
      <Arrow
        key={index}
        className={arrow.c}
        to={arrow.n ? arrow.n : arrow.l ? arrow.l : nextPage.n}
        name={arrow.a ?? nextPage.a}
        openInNewTab={arrow.openInNewTab}
        type={arrow.t}
      />
    )
  );
};
